/**
 * ORDERS STORE
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";

// import the api endpoints
import { getOrders, getOrder, printOrder, createOrders, updateOrders, deleteOrders, createFeInvoicesFromOrder } from "Modules/sales/orders/config/api.orders";

const state = {
    page: {},
    form: {},
    orders: [],
    selectedOrder: {
        order_id: null,
        company_id: "",
        order_date: "",
        reference_number: "",
        status_id: "",
        billing_address_id: "",
        shipping_address_id: "",
        comments: "",
        order_details: [],
    },
    orders_filter: {
        search: "",
        status_id: "",
        page_size: 2,
        page_num: 1,
    },
    rules_orders: {
        order_id: {
            name: "order_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        status_id: {
            name: "status_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        rfq_id: {
            name: "rfq_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        quote_id: {
            name: "quote_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        purchase_order_id: {
            name: "purchase_order_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        company_id: {
            name: "company_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        billing_address_id: {
            name: "billing_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        bill_address1: {
            name: "bill_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_address2: {
            name: "bill_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        bill_city: {
            name: "bill_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        bill_state: {
            name: "bill_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        bill_zip_code: {
            name: "bill_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        bill_zip_code_ext: {
            name: "bill_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        bill_country_iso_3: {
            name: "bill_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        shipping_address_id: {
            name: "shipping_address_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        ship_address1: {
            name: "ship_address1",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_address2: {
            name: "ship_address2",
            rules: "trim|max_length[255]",
            max_len: "255",
            min_len: "",
            default_value: "",
        },
        ship_city: {
            name: "ship_city",
            rules: "trim|max_length[100]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
        ship_state: {
            name: "ship_state",
            rules: "trim|max_length[65]",
            max_len: "65",
            min_len: "",
            default_value: "",
        },
        ship_zip_code: {
            name: "ship_zip_code",
            rules: "trim|max_length[5]",
            max_len: "5",
            min_len: "",
            default_value: "",
        },
        ship_zip_code_ext: {
            name: "ship_zip_code_ext",
            rules: "trim|max_length[4]",
            max_len: "4",
            min_len: "",
            default_value: "",
        },
        ship_country_iso_3: {
            name: "ship_country_iso_3",
            rules: "trim|max_length[3]",
            max_len: "3",
            min_len: "",
            default_value: "",
        },
        order_date: {
            name: "order_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        ship_date: {
            name: "ship_date",
            rules: "trim",
            max_len: "",
            min_len: "",
            default_value: "",
        },
        work_order_no: {
            name: "work_order_no",
            rules: "trim|max_length[20]",
            max_len: "20",
            min_len: "",
            default_value: "",
        },
        payment_term_id: {
            name: "payment_term_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        shipping_carrier_id: {
            name: "shipping_carrier_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        freight_term_id: {
            name: "freight_term_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        currency_id: {
            name: "currency_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        exchange_rate: {
            name: "exchange_rate",
            rules: "trim|max_length[19]|decimal|required",
            max_len: "19",
            min_len: "",
            default_value: "",
        },
        subtotal: {
            name: "subtotal",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        discount: {
            name: "discount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        discount_type: {
            name: "discount_type",
            rules: "trim|max_length[1]",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
        total_amount: {
            name: "total_amount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        customer_po: {
            name: "customer_po",
            rules: "trim|max_length[36]",
            max_len: "36",
            min_len: "",
            default_value: "",
        },
        comments: {
            name: "comments",
            rules: "trim",
            max_len: "65535",
            min_len: "",
            default_value: "",
        },
        expedite_fee: {
            name: "expedite_fee",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        handling_charge: {
            name: "handling_charge",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        freight: {
            name: "freight",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        customs: {
            name: "discount",
            rules: "trim|max_length[13]|decimal",
            max_len: "12",
            min_len: "",
            default_value: "",
        },
        department_id: {
            name: "department_id",
            rules: "trim|max_length[15]|integer|required",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        project_id: {
            name: "project_id",
            rules: "trim|max_length[15]|integer",
            max_len: "15",
            min_len: "",
            default_value: "",
        },
        order_details: {
            part_id: {
                name: "part_id",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            sales_unit: {
                name: "sales_unit",
                rules: "trim|max_length[15]|integer|required",
                max_len: "15",
                min_len: "",
                default_value: "",
            },
            cost_price: {
                name: "cost_price",
                rules: "trim|max_length[13]|decimal",
                max_len: "12",
                min_len: "",
                default_value: "",
            },
            unit_price: {
                name: "unit_price",
                rules: "trim|max_length[13]|decimal|required",
                max_len: "12",
                min_len: "",
                default_value: "0.000",
            },
            quantity: {
                name: "quantity",
                rules: "trim|max_length[11]|integer|required",
                max_len: "11",
                min_len: "",
                default_value: "",
            },
            line_discount_amount: {
                name: "line_discount_amount",
                rules: "trim|max_length[10]|decimal",
                max_len: "10",
                min_len: "",
                default_value: "",
            },
            line_discount_percentage: {
                name: "line_discount_percentage",
                rules: "trim|max_length[10]|decimal",
                max_len: "10",
                min_len: "",
                default_value: "",
            },
            line_discount_type: {
                name: "line_discount_type",
                rules: "trim|max_length[1]",
                max_len: "1",
                min_len: "",
                default_value: "",
            },
            lead_time: {
                name: "lead_time",
                rules: "trim|max_length[3]|integer",
                max_len: "3",
                min_len: "",
                default_value: "",
            },
        },
    },
};

// getters
const getters = {
    orders: (state) => {
        return state.orders;
    },
};

// actions
const actions = {
    async fetchOrders({ rootState, commit, dispatch }, payload = null) {
        try {
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            const response = await getOrders({ body: body, headers: config.headers });

            if (typeof response !== "undefined" && response.data) {
                if (response.data.page) {
                    commit("setPageOrders", response.data.page);
                }

                commit("setOrders", response.data.orders);

                return response.data;
            } else {
                console.log("fetch all response error");
                return;
            }
        } catch (error) {
            console.log("fetch all error");
            return;
        }
    },
    async fetchOrder({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let body = payload.body ? payload.body : "";
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await getOrder(payload.id);

            if (typeof response !== "undefined" && response.data) {
                commit("setSelectedOrder", response.data.order);
                return response.data;
            } else {
                console.log("fetch response error");
                return;
            }
        } catch (error) {
            console.log("fetch single error");
            return;
        }
    },
    async printOrder({ rootState, commit, dispatch }, payload = null) {
        try {
            let response = null;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await printOrder(payload.id, payload.view_as);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("fetch print response error");
                return;
            }
        } catch (error) {
            console.log("print error");
            return;
        }
    },
    async saveOrder({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            if (typeof body["order_id"] === "undefined" || body["order_id"] == null || body["order_id"] == "") {
                delete body["order_id"];
                response = await createOrders({ body: body, headers: config.headers });
            } else {
                let order_id = body["order_id"];
                delete body["order_id"];
                response = await updateOrders({ body: body, headers: config.headers }, order_id);
            }

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async convertOrderToInvoice({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            let order_id = body["order_id"];
            delete body["order_id"];
            response = await createFeInvoicesFromOrder({ body: body, headers: config.headers }, order_id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("save response error");
                return;
            }
        } catch (error) {
            console.log("save error");
            return;
        }
    },
    async deleteOrder({ rootState, commit, dispatch }, payload) {
        try {
            let response = null;
            let body = payload.body;
            let config = {
                headers: payload.headers ? payload.headers : {},
            };

            response = await deleteOrders(payload.id);

            if (typeof response !== "undefined" && response.data) {
                return response.data;
            } else {
                console.log("delete response error");
                return;
            }
        } catch (error) {
            console.log("delete error");
            return;
        }
    },
};

// mutations
const mutations = {
    setPageOrders(state, page) {
        state.page = page;
    },
    setOrders(state, orders) {
        state.orders = orders;
    },
    setSelectedOrder(state, order) {
        state.selectedOrder = order;
    },
    resetSelectedOrder(state) {
        for (const key in state.selectedOrder) {
            if (key in state.rules_orders) {
                state.selectedOrder[key] = state.rules_orders[key].default_value == "null" ? null : state.rules_orders[key].default_value;
            }
        }
    },
    resetOrders(state) {
        state.page = {};
        state.orders = [];
        state.selectedOrder = {
            order_id: null,
            company_id: "",
            order_date: "",
            reference_number: "",
            status_id: "",
            billing_address_id: "",
            shipping_address_id: "",
            comments: "",
            order_details: [],
        };
        state.orders_filter = {
            search: "",
            status_id: "",
            page_size: 2,
            page_num: 1,
        };
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
